import { convertFromRaw } from "draft-js";

/**
 * Extracts plain text from Draft.js content
 * @param content - Draft.js content as string (JSON) or object
 * @param maxLength - Maximum length of the extracted text (default: 155 for meta descriptions)
 * @returns Plain text string, truncated if necessary
 */
export const extractPlainText = (
  content: string | object,
  maxLength: number = 155
): string => {
  try {
    let contentObject: any;

    // Parse if string, use directly if object
    if (typeof content === "string") {
      try {
        contentObject = JSON.parse(content);
      } catch (error) {
        console.error("Failed to parse string content:", error);
        return "";
      }
    } else if (typeof content === "object" && content !== null) {
      contentObject = content;
    } else {
      return "";
    }

    // Check if content has blocks
    if (!contentObject || !contentObject.blocks || !Array.isArray(contentObject.blocks)) {
      return "";
    }

    // Convert to Draft.js ContentState and extract plain text
    const contentState = convertFromRaw(contentObject);
    let plainText = contentState.getPlainText().trim();

    // Remove extra whitespace and newlines
    plainText = plainText.replace(/\s+/g, " ");

    // Truncate if necessary
    if (plainText.length <= maxLength) {
      return plainText;
    }

    // Truncate at word boundary
    let endIndex = maxLength;
    while (endIndex > 0 && plainText[endIndex] !== " ") {
      endIndex--;
    }

    if (endIndex === 0) {
      endIndex = maxLength;
    }

    return plainText.slice(0, endIndex).trim() + "...";
  } catch (error) {
    console.error("Error extracting plain text:", error);
    return "";
  }
};
